/** @enum {CommitmentRangesEnum} */
angular.module('capability-ng-scheduler').constant(
  'CommitmentRangesEnum',
  Enumeration('CommitmentRangesEnum', {
    WORK_HRS: {
      id: 'work_hrs',
      title: 'Working at a Job',
      label: 'Working at a job',
      shortTitle: 'At a Job',
      value: 0,
      min: 0,
      max: 40
    },
    EXTRACURRICULAR_HRS: {
      id: 'extracurricular_hrs',
      title: 'Activities, Sports, Clubs, Organizations, etc.',
      label: 'Activities, Sports, Clubs, Organizations, etc.',
      shortTitle: 'Outside Activities',
      value: 0,
      min: 0,
      max: 40
    },
    COMMUNITY_HRS: {
      id: 'community_hrs',
      title: 'Community or Other Activities',
      label: 'Community or other activities',
      shortTitle: 'Community Service',
      value: 0,
      min: 0,
      max: 40
    }
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/components/commitment_range/types/commitment_ranges_enum.js